import {SwiperClass} from 'swiper/react'
import {NavigationSeparators} from './Separators'
import {Icon} from 'src/common/Icon'
import {motion} from 'framer-motion'
import cn from 'classnames'
import {RefObject} from 'react'

const GRID_ROWS_NAVIGATION = 'grid-rows-[64px_40px] md:grid-rows-[80px_38px] lg:grid-rows-[80px_80px]'

const GRID_COLS_NAVIGATION =
  'grid-cols-[20px_auto_20px] md:grid-cols-[60px_24px_auto_24px_60px] lg:grid-cols-[auto_24px_minmax(auto,1152px)_24px_auto]'

export const Navigation = ({
  swiperInstance,
  activeIndex,
  elements,
  progressBarRef,
}: {
  swiperInstance: SwiperClass | null
  activeIndex: number
  elements: number
  progressBarRef: RefObject<HTMLDivElement>
}) => {
  const elementsArray = Array.from({length: elements}, (_, i) => i)
  return (
    <div className={`grid ${GRID_ROWS_NAVIGATION} ${GRID_COLS_NAVIGATION} ml-[-1px] w-full`}>
      <NavigationSeparators />
      <div className="col-span-1 col-start-2 row-span-1 row-start-1 ml-[-1px] mt-[-1px] flex items-center justify-center rounded-[4px] border-[1px] border-[#345142] md:col-start-3">
        <div className="flex items-center max-md:mx-6 max-md:w-full max-md:justify-between md:gap-16 lg:gap-12">
          <button onClick={() => swiperInstance?.slidePrev()} className="flex items-center justify-center">
            <Icon
              name="arrow"
              className={cn('h-3 w-[13px] scale-x-flip', {
                'text-[#345142]': activeIndex === 0,
                'text-green-neon': activeIndex > 0,
              })}
            />
          </button>
          <div className="flex gap-2">
            {elementsArray.map((_, index) => (
              <div
                key={`nav-dot-${index}`}
                className={cn('relative h-2 overflow-hidden rounded-[1px] bg-[#345142] transition-all duration-700', {
                  'w-2': index !== activeIndex,
                  'w-8': index === activeIndex,
                })}
              >
                {index === activeIndex && (
                  <motion.div ref={progressBarRef} className="absolute z-10 h-full w-full origin-left bg-green-neon" />
                )}
              </div>
            ))}
          </div>
          <button onClick={() => swiperInstance?.slideNext()} className="flex items-center justify-center">
            <Icon
              name="arrow"
              className={cn('h-3 w-[13px]', {
                'text-green-neon': activeIndex < elements - 1,
                'text-[#345142]': activeIndex === elements - 1,
              })}
            />
          </button>
        </div>
      </div>
    </div>
  )
}
